module.exports = __webpack_public_path__ + "static/media/6_of_clubs.3708c7e5.svg";